import { render, staticRenderFns } from "./FileImporter.html?vue&type=template&id=44f5e44e&external"
import script from "./FileImporter.ts?vue&type=script&lang=ts&external"
export * from "./FileImporter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports